import React, { Component } from "react";
import axios from "axios";
import Media from "react-media";

import theme from "config/theme";
import { rss2jsonKey } from "config/keys";
import { markdownify } from "config/utils";

import Slider, { ArrowButton } from "components/Slider";
import Loader from "components/Loader";
import { BlockWrapper } from "components/Block";
import SubscribeForm from "components/SubscribeForm";

import Article from "./Article";

import { Header, Heading, Inner } from "./styles";

class LatestArticles extends Component {
  state = {
    posts: [],
    isLoading: true
  };

  fetchArticles() {
    const tagFeed = this.props.tag ? `/tagged/${this.props.tag}` : "";
    axios
      .get(
        `https://api.rss2json.com/v1/api.json?rss_url=https://medium.com/feed/clearmatics${tagFeed}`,
        {
          params: {
            api_key: rss2jsonKey,
            count: 5
          }
        }
      )
      .then(res => {
        this.setState({
          posts: res.data.items,
          isLoading: false
        });
      })
      .catch(error => this.setState({ error, isLoading: false }));
  }

  componentDidMount() {
    this.fetchArticles();
  }

  render() {
    const { posts, isLoading } = this.state;
    const { content, ...props } = this.props;

    const settings = {
      dots: false,
      speed: 300,
      infinite: true,
      variableWidth: true,
      centerMode: true,
      centerPadding: "40px",
      nextArrow: <ArrowButton type="next" />,
      prevArrow: <ArrowButton type="previous" />,
      responsive: [
        {
          breakpoint: 700,
          settings: {
            centerPadding: "10px"
          }
        }
      ]
    };

    return (
      <BlockWrapper
        display="block"
        pt={["30px", "40px"]}
        pb="20px"
        shade="medium"
        zIndex="3"
        {...props}
      >
        <Header>
          <Heading
            dangerouslySetInnerHTML={{
              __html: markdownify(content.heading || "Latest Articles")
            }}
          />
          <Media query={{ minWidth: theme.size.tablet }}>
            {matches =>
              matches && <SubscribeForm maxWidth="260px" size="small" />
            }
          </Media>
        </Header>
        <Inner>
          {isLoading ? (
            <Loader mt="120px" size="100px" color={theme.color.primary} />
          ) : (
            <Slider innerRef={ref => (this.slider = ref)} {...settings}>
              {posts.map((post, index) => (
                <Article key={index} content={post} {...settings}>
                  {post.title}
                </Article>
              ))}
            </Slider>
          )}
        </Inner>
      </BlockWrapper>
    );
  }
}

export default LatestArticles;
